import React, {FC, useEffect, useState} from "react";
import {handleError} from "../error/ErrorHandler";
import axios from "axios";

const ShineDataSummary: FC = () => {

    const [ requestCount, setRequestCount ] = useState(0);
    const [ doneCount, setDoneCount ] = useState(0);
    const [ allCount, setAllCount ] = useState(0);

    const getAllCount = async() => {
        try {
            const res = await axios.get(`api/data/count/all`);
            if (res.data) setAllCount(res.data);
        } catch (err) {
            handleError(err);
        }
    }

    const getRequestCount = async() => {
        try {
            const res = await axios.get(`api/data/count/request`);
            if (res.data) setRequestCount(res.data);
        } catch (err) {
            handleError(err);
        }
    }

    const getDoneCount = async() => {
        try {
            const res = await axios.get(`api/data/count/done`);
            if (res.data) setDoneCount(res.data);
        } catch (err) {
            handleError(err);
        }
    }

    useEffect(() => {
        getAllCount();
        getRequestCount();
        getDoneCount();
    }, []);

    return (
        <div className={'shine-data-summary-wrapper'}>
            <div className={'shine-data-summary'}>
                <div className={'shine-data-summary-title'}>
                    데이터 현황
                </div>
                <div className={'shine-data-summary-item-wrapper'}>
                    <div className={'shine-data-summary-item'}>
                        <div className={'shine-data-summary-item-label'}>
                            신청 완료
                        </div>
                        <div className={'shine-data-summary-item-count'}>
                            {allCount} 건
                        </div>
                    </div>
                    <div className={'shine-data-summary-item'}>
                        <div className={'shine-data-summary-item-label'}>
                            처리 중
                        </div>
                        <div className={'shine-data-summary-item-count'}>
                            {requestCount} 건
                        </div>
                    </div>
                    <div className={'shine-data-summary-item'}>
                        <div className={'shine-data-summary-item-label'}>
                            처리 완료
                        </div>
                        <div className={'shine-data-summary-item-count'}>
                            {doneCount} 건
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShineDataSummary;
